module.exports = __webpack_public_path__ + "img/pinterest_black.cd1682ae.png";